// DROP aggiunta 03/07/2026
(() => {
  const fixPercentage = (form, variant) => {
    if (!variant) return;
    const { compare_at_price: compareAt, price } = variant;
    const el = form.closest('.product-page__info')?.querySelector('[data-percentage]');
    if (!el) return;

    if (compareAt > price) {
      el.innerText = `-${Math.round(((compareAt - price) * 100) / compareAt)}%`;
      el.style.display = '';
    } else {
      el.innerText = '';
      el.style.display = 'none';
    }
  };

  document.querySelectorAll('.product-page__form').forEach((form) => {
    form.addEventListener('afterVariantChange', (e) => fixPercentage(form, e.variant));
  });
})();